import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import Inscrits from './pages/Inscrits'
import Pointage from './pages/Pointage'
import Dashboard from './pages/Dashboard'
import Admin from './pages/Admin'
import Import from './pages/Import'
import Auth from './Auth'
import './App.css'

const ICON_RETRAITS = String.fromCodePoint(0x1F3F7)
const ICON_POINTAGE = String.fromCodePoint(0x23F1)
const ICON_DASHBOARD = String.fromCodePoint(0x1F4CA)
const ICON_IMPORT = String.fromCodePoint(0x1F4E5)
const ICON_ADMIN = String.fromCodePoint(0x2699)

export default function App() {
  const [role, setRole] = useState(null)
  const [courses, setCourses] = useState([])
  const [checkingSession, setCheckingSession] = useState(true)

  useEffect(() => {
    const savedRole = sessionStorage.getItem('role')
    if (savedRole) setRole(savedRole)
    setCheckingSession(false)
  }, [])

  useEffect(() => {
    if (role) {
      supabase.from('courses').select('*').order('nom').then(({ data }) => setCourses(data || []))
    }
  }, [role])

  function handleLogin(newRole) { setRole(newRole) }
  function handleLogout() { sessionStorage.removeItem('role'); setRole(null) }

  if (checkingSession) return null
  if (!role) return <Auth onLogin={handleLogin} />

  const isAdmin = role === 'admin'

  return (
    <BrowserRouter>
      <div className="app">
        {/* NAV DESKTOP - haut */}
        <nav className="nav nav-desktop">
          <div className="nav-title">{String.fromCodePoint(0x1F6B5)} Course Event</div>
          <NavLink to="/" end>Retraits</NavLink>
          <NavLink to="/pointage">Pointage</NavLink>
          <NavLink to="/dashboard">Dashboard</NavLink>
          {isAdmin && <NavLink to="/import">Import</NavLink>}
          {isAdmin && <NavLink to="/admin">Admin</NavLink>}
          <div style={{marginLeft:'auto', display:'flex', alignItems:'center', gap:10}}>
            <span className="role-badge">{isAdmin ? 'Admin' : 'Benevole'}</span>
            <button onClick={handleLogout} className="logout-btn">Deconnexion</button>
          </div>
        </nav>

        {/* HEADER MOBILE - haut simplifie */}
        <div className="mobile-header">
          <div className="nav-title">{String.fromCodePoint(0x1F6B5)} Course Event</div>
          <div style={{display:'flex', alignItems:'center', gap:8}}>
            <span className="role-badge">{isAdmin ? 'Admin' : 'Benevole'}</span>
            <button onClick={handleLogout} className="logout-btn-mobile">
              {String.fromCodePoint(0x23FB)}
            </button>
          </div>
        </div>

        <main className="main">
          <Routes>
            <Route path="/" element={<Inscrits isAdmin={isAdmin} />} />
            <Route path="/pointage" element={<Pointage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {isAdmin && <Route path="/import" element={<Import courses={courses} />} />}
            {isAdmin && <Route path="/admin" element={<Admin />} />}
            <Route path="*" element={<div style={{padding:40, textAlign:'center', color:'#888'}}>Page non accessible</div>} />
          </Routes>
        </main>

        {/* NAV MOBILE - barre du bas */}
        <nav className="nav-bottom">
          <NavLink to="/" end className="nav-bottom-item">
            <span className="nav-bottom-icon">{ICON_RETRAITS}</span>
            <span>Retraits</span>
          </NavLink>
          <NavLink to="/pointage" className="nav-bottom-item">
            <span className="nav-bottom-icon">{ICON_POINTAGE}</span>
            <span>Pointage</span>
          </NavLink>
          <NavLink to="/dashboard" className="nav-bottom-item">
            <span className="nav-bottom-icon">{ICON_DASHBOARD}</span>
            <span>Dashboard</span>
          </NavLink>
          {isAdmin && (
            <NavLink to="/import" className="nav-bottom-item">
              <span className="nav-bottom-icon">{ICON_IMPORT}</span>
              <span>Import</span>
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin" className="nav-bottom-item">
              <span className="nav-bottom-icon">{ICON_ADMIN}</span>
              <span>Admin</span>
            </NavLink>
          )}
        </nav>
      </div>
    </BrowserRouter>
  )
}
